import { ChevronUp, ChevronDown } from 'lucide-react'

import { Button } from '@/components/ui/button'

interface Props {
  onUp: () => void
  disabledUp: boolean
  onDown: () => void
  disabledDown: boolean
}
const OrderButtons = ({ onUp, onDown, disabledUp, disabledDown }: Props) => {
  return (
    <div className="flex flex-col justify-evenly">
      <Button
        variant="ghost"
        size="sm"
        disabled={disabledUp}
        onClick={(e) => {
          onUp()
          e.stopPropagation()
        }}
      >
        <ChevronUp className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        disabled={disabledDown}
        onClick={(e) => {
          onDown()
          e.stopPropagation()
        }}
      >
        <ChevronDown className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default OrderButtons
